<div class="auth-container">
  <div class="container-text-login">
    <div class="container-text">
      <div style="margin-bottom: 25px">
        <div>
          <svg width="300" height="250" viewBox="0 0 887 446" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M886.37 385.026H829.832V441.585H886.37V385.026Z" fill="white" />
            <path
              d="M715.088 133.19L748.767 385.985L782.404 133.19H834.888L785.802 441.585H711.179L662.615 133.19H715.088Z"
              fill="white"
            />
            <path
              d="M29.636 133.19H0.543274V174.176H29.636V441.585H80.7849V174.176H116.716V133.19H80.7849V70.5017C80.7849 61.3601 82.682 54.3556 87.0913 49.5815C91.5213 44.8179 98.3177 42.5664 107.491 42.5664H116.705V0.621429H98.2031C75.469 0.621429 53.5792 5.4266 43.1555 15.3187C32.7526 25.2004 29.636 40.5544 29.636 62.4442V133.19Z"
              fill="white"
            />
            <path d="M132.684 441.585H183.959V133.19H132.684V441.585Z" fill="white" />
            <path
              d="M420.691 304.847H527.576V209.804C527.44 152.943 500.099 129.636 448.325 129.636C394.455 129.636 369.219 152.891 369.219 210.169V366.358C369.365 418.476 400.928 445.421 448.293 445.421C495.659 445.421 527.441 423.24 527.576 366.358V341.664H478.053L478.111 370.934C478.111 391.802 470.294 406.249 449.321 406.249C428.338 406.249 420.687 391.677 420.687 370.902L420.691 304.847ZM420.691 199.568C420.691 182.171 425.215 164.159 449.179 164.159C473.144 164.159 478.011 181.91 478.011 199.547V263.288H420.691V199.568Z"
              fill="white"
            />
            <path
              d="M299.245 266.259C260.354 232.476 257.321 227.597 257.321 202.434C257.321 180.983 259.187 167.932 278.45 167.932C297.692 167.932 300.214 180.826 300.214 202.674V231.141H349.623V184.693C349.466 148.221 321.395 129.667 277.313 129.667C233.961 129.667 205.671 144.103 205.431 202.434C205.398 212.337 205.44 212.337 205.431 208.512C205.515 226.847 205.598 255.898 250.921 294.789L263.909 305.911C297.296 334.075 300.965 337.473 300.798 370.965C300.781 391.604 299.516 407.25 277.845 407.25C256.174 407.25 254.819 391.489 254.819 381.753V342.3H202.951V383.015C202.951 433.111 235.546 445.505 277.783 445.505C320.051 445.505 352.708 432.996 352.708 368.526V363.168C352.593 318.137 344.442 306.056 299.245 266.259Z"
              fill="white"
            />
            <path
              d="M596.195 164.94V133.19H549.476V441.575H599.885V226.659C599.852 210.044 605.274 199.109 614.697 192.647C623.62 186.497 634.607 184.412 648.564 184.214V129.656C621.817 130.198 610.288 135.483 596.716 163.815L596.195 164.94Z"
              fill="white"
            />
          </svg>
        </div>
        <br />
        <span
          ><b class="text-login">{{ 'pages.login.text.subtitle1' | translate }}</b></span
        ><br />
        <span
          ><b class="text-login">{{ 'pages.login.text.subtitle2' | translate }} </b></span
        >
      </div>
      <div>
        <span class="text-login">{{ 'pages.login.text.subtitle3' | translate }}</span
        ><br />
        <span class="text-login">{{ 'pages.login.text.subtitle4' | translate }}</span>
      </div>
    </div>
    <div class="auth-box">
      <form *ngIf="!twoAF" class="auth-form" [formGroup]="myForm" (ngSubmit)="preAuthorizeLogin()">
        <div class="auth-box-logo">
          <svg width="300" height="250" viewBox="0 0 887 446" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M886.37 385.026H829.832V441.585H886.37V385.026Z" fill="white" />
            <path
              d="M715.088 133.19L748.767 385.985L782.404 133.19H834.888L785.802 441.585H711.179L662.615 133.19H715.088Z"
              fill="white"
            />
            <path
              d="M29.636 133.19H0.543274V174.176H29.636V441.585H80.7849V174.176H116.716V133.19H80.7849V70.5017C80.7849 61.3601 82.682 54.3556 87.0913 49.5815C91.5213 44.8179 98.3177 42.5664 107.491 42.5664H116.705V0.621429H98.2031C75.469 0.621429 53.5792 5.4266 43.1555 15.3187C32.7526 25.2004 29.636 40.5544 29.636 62.4442V133.19Z"
              fill="white"
            />
            <path d="M132.684 441.585H183.959V133.19H132.684V441.585Z" fill="white" />
            <path
              d="M420.691 304.847H527.576V209.804C527.44 152.943 500.099 129.636 448.325 129.636C394.455 129.636 369.219 152.891 369.219 210.169V366.358C369.365 418.476 400.928 445.421 448.293 445.421C495.659 445.421 527.441 423.24 527.576 366.358V341.664H478.053L478.111 370.934C478.111 391.802 470.294 406.249 449.321 406.249C428.338 406.249 420.687 391.677 420.687 370.902L420.691 304.847ZM420.691 199.568C420.691 182.171 425.215 164.159 449.179 164.159C473.144 164.159 478.011 181.91 478.011 199.547V263.288H420.691V199.568Z"
              fill="white"
            />
            <path
              d="M299.245 266.259C260.354 232.476 257.321 227.597 257.321 202.434C257.321 180.983 259.187 167.932 278.45 167.932C297.692 167.932 300.214 180.826 300.214 202.674V231.141H349.623V184.693C349.466 148.221 321.395 129.667 277.313 129.667C233.961 129.667 205.671 144.103 205.431 202.434C205.398 212.337 205.44 212.337 205.431 208.512C205.515 226.847 205.598 255.898 250.921 294.789L263.909 305.911C297.296 334.075 300.965 337.473 300.798 370.965C300.781 391.604 299.516 407.25 277.845 407.25C256.174 407.25 254.819 391.489 254.819 381.753V342.3H202.951V383.015C202.951 433.111 235.546 445.505 277.783 445.505C320.051 445.505 352.708 432.996 352.708 368.526V363.168C352.593 318.137 344.442 306.056 299.245 266.259Z"
              fill="white"
            />
            <path
              d="M596.195 164.94V133.19H549.476V441.575H599.885V226.659C599.852 210.044 605.274 199.109 614.697 192.647C623.62 186.497 634.607 184.412 648.564 184.214V129.656C621.817 130.198 610.288 135.483 596.716 163.815L596.195 164.94Z"
              fill="white"
            />
          </svg>
        </div>

        <div class="text-pix">
          <span
            >Pix, el sistema de pagos digitales de Brasil, ya está disponible en Argentina gracias a Fiserv. Ahora, en
            tu Clover, vas a poder aceptar pagos de turistas brasileros de manera práctica, rápida y segura a través de
            la app PIX.</span
          >
        </div>

        <mat-form-field class="input-yaca input-yaca-login">
          <mat-label>E-mail</mat-label>
          <input
            matInput
            #inputAccount
            type="email"
            placeholder="E-mail"
            [errorStateMatcher]="loginErrorMatcher"
            formControlName="email"
            name="email"
            required
            autocomplete="off"
          />
          <mat-hint>
            <mat-checkbox formControlName="remember" class="remember-email"
              >{{ 'pages.login.labels.remember_email' | translate }}
            </mat-checkbox>
          </mat-hint>
          <mat-error *ngIf="myForm.controls.email.invalid && myForm.controls.email.dirty" class="error">
            {{ 'pages.login.messages.invalid_email' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="input-yaca">
          <mat-label>Contraseña</mat-label>
          <input
            matInput
            #inputPassword
            type="password"
            placeholder="Contraseña"
            [errorStateMatcher]="loginErrorMatcher"
            formControlName="password"
            name="password"
            required
            autocomplete="off"
          />

          <!-- <mat-icon matSuffix (mousedown)="togglePassword(true)" (mouseup)="togglePassword(false)"
            (mouseleave)="togglePassword(false)" (touchstart)="togglePassword(true)" (touchend)="togglePassword(false)"
            (touchcancel)="togglePassword(false)" class="clickeable">
            {{ passwordType === 'password' ? 'visibility_off' : 'visibility' }}
          </mat-icon> -->

          <mat-icon
            matSuffix
            *ngIf="passwordType === 'password'"
            (click)="togglePassword(inputPassword)"
            class="eye-toggle"
          >
            <img class="icon-eye" src="assets/icons/eye_open.svg" srcset="" />
          </mat-icon>
          <mat-icon
            matSuffix
            *ngIf="passwordType === 'text'"
            (click)="togglePassword(inputPassword)"
            class="eye-toggle"
          >
            <img class="icon-eye" src="assets/icons/eye_closed.svg" srcset="" />
          </mat-icon>

          <mat-error *ngIf="myForm.get('password').errors?.required" class="error">
            {{ 'pages.login.messages.required_password' | translate }}
          </mat-error>
        </mat-form-field>

        <div class="content-text">
          <span (click)="routerNavigate('/restore')" class="recovery-span fiserv55"
            >Recuperar o cambiar contraseña</span
          >
          <span *ngIf="!isClover" (click)="routerNavigate('/remove-device-request')" class="recovery-span fiserv55"
            >Perdí mi celular</span
          >
        </div>

        <div class="auth-btn-box">
          <button
            class="auth-btn font-clear"
            mat-raised-button
            type="submit"
            [disabled]="myForm.invalid || loading"
            color="primary"
          >
            {{ loginBtnText }}
          </button>

          <div class="sep-btn"></div>
        </div>
      </form>
      <br />
      <div *ngIf="!twoAF" class="auth-box-footer">
        <span>Al registrarte, estas aceptando los</span>
        <a href="{{ URL }}Terminos-y-Condiciones" target="_blank">{{
          'pages.login.labels.terms_and_conditions' | translate
        }}</a>
      </div>
    </div>
  </div>
</div>
